import React from 'react'
import InertiaHead from '@inertiajs/inertia-react/src/Head'

const Head = InertiaHead;

export default Head;
